import React from "react";
import { Button, View, Text } from "react-native";
import ManaBtn from "../components/ManaBtn";

class PageLoginErr extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.state = { show: false };
    const that = this;
    setTimeout(() => {
      that.state.show = true;
    }, 3000);
  }

  render() {
    const onRetry = this.onRetry.bind(this);
    const show = this.state.show;

    return (
      <View style={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
        {show ? (
          <>
            <Text>{"Authenticate"}</Text>
            <Text> </Text>
            <ManaBtn onPress={onRetry} title="Retry" />
          </>
        ) : null}
      </View>
    );
  }

  onRetry() {
    if (this.controller.hasNavigation()) {
      this.props.navigation.navigate("login");
    } else {
      this.controller.changePage("login");
    }
  }
}

export default PageLoginErr;
